import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 40, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function LineReveal({ lines, className = "", delay = 0, italicIndex = null }) {
  return (
    <div className={className}>
      {lines.map((l, i) => (
        <span key={i} className="reveal-mask">
          <motion.span
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.1, delay: delay + i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className={`block ${italicIndex === i ? "italic" : ""}`}
          >
            {l}
          </motion.span>
        </span>
      ))}
    </div>
  );
}
